export default __webpack_public_path__ + "static/media/p2.007b05f2.jpeg";